import { apiFetch } from './client.js';

export async function fetchCurrentProgram() {
  return apiFetch('/player/current-program', { silent: true, cache: 'no-store' });
}
